var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "pm-list-item-template" }, [
    _c(
      "div",
      [
        _c(_setup.PMListItemFloorForm, {
          attrs: { pmListId: _vm.pmListId },
          on: { onAddFloorForm: _setup.onAddFloorForm }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "box-bubble index" },
      [
        _c(_setup.PMListItemIndex, {
          ref: "pmListItemIndexRef",
          attrs: { "pm-list-id": _vm.pmListId }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }